import {Component, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {TranslocoPipe} from '@jsverse/transloco';
import {BackgroundCardComponent} from '../../../shared/components/titled-background-card/background-card.component';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {SelecthorAdminProviderInvoicesComponent} from './selecthor-admin-provider-invoices/selecthor-admin-provider-invoices.component';
import {TabsUnsavedRevealDirective} from '../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-selecthor-admin-invoices-list',
  templateUrl: './selecthor-admin-invoices.component.html',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    TranslocoPipe,
    BackgroundCardComponent,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    SelecthorAdminProviderInvoicesComponent,
    TabsUnsavedRevealDirective,
  ],
})
export class SelecthorAdminInvoicesComponent {
  activeTabIndex = signal('providerInvoices');
}
